import * as React from "react";

interface Props {
    label?: string | JSX.Element;
    textSize?: "sm";
    prefix: string | JSX.Element;
}
const InputWithPrefix: React.ForwardRefExoticComponent<
    Props &
        React.InputHTMLAttributes<HTMLInputElement> &
        React.RefAttributes<HTMLInputElement>
> = React.forwardRef<
    HTMLInputElement,
    Props & React.InputHTMLAttributes<HTMLInputElement>
>((props, ref) => {
    const { label, className, textSize, prefix, ...rest } = props;

    let textSizeClass = "";

    switch (textSize) {
        case "sm":
            textSizeClass = "text-sm";
            break;
    }

    return (
        <div className={`${className ?? ""} w-full`}>
            <label>
                {label ? <div className="mb-1">{label}</div> : null}
                <div className="flex items-center rounded-sm md:rounded border border-gray-300 hover:border-brand-600 focus-within:border-brand-400 focus-within:ring-2 focus-within:ring-brand-300 disabled:bg-gray-100 py-2 px-3">
                    <div
                        className={`shrink-0 select-none text-gray-500 ${textSizeClass}`}>
                        {prefix}
                    </div>
                    <input
                        ref={ref}
                        className={`block min-w-0 grow pl-1 border-0 bg-transparent focus:ring-0 focus:outline-none disabled:bg-transparent ${textSizeClass}`}
                        {...rest}
                    />
                </div>
            </label>
        </div>
    );
});

InputWithPrefix.displayName = "InputWithPrefix";
export { InputWithPrefix };
